import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from './shared-data.service';
import { UserPermission } from 'app/interfaces/permission';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getPermissions = (callback = (data) => data) => {
    this.httpClient.get('/security').subscribe(data => {
      callback(data)
    })
  }

  getPermissionsToPromise = () => {
    return this.httpClient.get('/security').toPromise()
  }

  async hasPermission(ref1: string, ref2: string, permission: string) {
    try {
      const permissions = await this.getPermissionsToPromise()
      return permissions[ref1][ref2].includes(permission)
    } catch (err) {
      console.log(err)
    }
  }

  validatePermission = (permissions: UserPermission, spectedPermission: string, group: string) => {
    console.log('validatePermission', {permissions, spectedPermission, group})
  }
}
